import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, Row, Col, Form, Badge } from 'react-bootstrap';
const formatearFecha = (fechaString) => {
    if (!fechaString) return '';
    const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    const partes = fechaString.split('T')[0].split('-');
    if (partes.length !== 3) return fechaString;
    const year = partes[0];
    const month = parseInt(partes[1], 10) - 1;
    const day = partes[2];
    return `${day}-${meses[month]}-${year}`;
};

const EstadoCuentaLista = ({ rfcSeleccionado, movimientosFiltrados, movimientosSeleccionados = [], toggleSeleccionMovimiento, toggleSeleccionTodos, esConciliadosTab, onMovimientoClick, cargandoConciliacion }) => {
    const todosSeleccionados = movimientosFiltrados && movimientosFiltrados.length > 0 && movimientosSeleccionados.length === movimientosFiltrados.length;

    return (
        <div style={{ maxHeight: '500px', overflowY: 'auto', opacity: cargandoConciliacion ? 0.6 : 1, pointerEvents: cargandoConciliacion ? 'none' : 'auto' }}>
            <ListGroup variant="flush">
                {!rfcSeleccionado ? (
                    <ListGroup.Item className="text-center text-600 py-5">
                        <i className="fas fa-exclamation-triangle fa-2x mb-3 text-warning"></i>
                        <p className="mb-0">Seleccione un RFC para ver los movimientos</p>
                    </ListGroup.Item>
                ) : movimientosFiltrados && movimientosFiltrados.length > 0 ? (
                    <>
                        <ListGroup.Item className="bg-light border-bottom py-2 d-flex justify-content-between align-items-center">
                            {!esConciliadosTab ? (
                                <>
                                    <Form.Check
                                        type="checkbox"
                                        id="check-all-movs"
                                        label={<span className="fw-bold text-600 fs--1 ms-1">Seleccionar Todos</span>}
                                        checked={todosSeleccionados}
                                        onChange={(e) => toggleSeleccionTodos(e.target.checked)}
                                        className="mb-0"
                                    />
                                    {movimientosSeleccionados.length > 1 && (
                                        <span className="fw-bold text-primary fs--1">
                                            Total: ${movimientosSeleccionados.reduce((acc, m) => acc + m.monto, 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                        </span>
                                    )}
                                </>
                            ) : (
                                <span className="fw-bold text-600 fs--1 ms-1">Movimientos Conciliados</span>
                            )}
                        </ListGroup.Item>
                        {movimientosFiltrados.map((movimiento) => (
                            <ListGroup.Item
                                key={movimiento.id}
                                className={`border-start border-4 hover-shadow transition-base ${!esConciliadosTab && movimientosSeleccionados.some(m => m.id === movimiento.id) ? 'bg-soft-primary' : ''}`}
                                style={{
                                    borderColor: movimiento.tipo === 'I' ? '#28a745' : '#dc3545',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    if (esConciliadosTab && onMovimientoClick) {
                                        onMovimientoClick(movimiento);
                                    } else if (!esConciliadosTab) {
                                        toggleSeleccionMovimiento(movimiento);
                                    }
                                }}
                            >
                                <Row className="align-items-center">
                                    <Col xs={1} className="text-center px-1">
                                        {!esConciliadosTab && (
                                            <Form.Check
                                                type="checkbox"
                                                id={`check-mov-${movimiento.id}`}
                                                className="mb-0"
                                                checked={movimientosSeleccionados.some(m => m.id === movimiento.id)}
                                                onChange={() => toggleSeleccionMovimiento(movimiento)}
                                                onClick={(e) => e.stopPropagation()}
                                                style={{ transform: 'scale(1.2)' }}
                                            />
                                        )}
                                    </Col>
                                    <Col xs={2} className="text-center px-1">
                                        <div
                                            className={`rounded-circle d-inline-flex align-items-center justify-content-center`}
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                backgroundColor: movimiento.tipo === 'I' ? '#d4edda' : '#f8d7da'
                                            }}
                                        >
                                            <i
                                                className={`fas ${movimiento.tipo === 'I' ? 'fa-arrow-down text-success' : 'fa-arrow-up text-danger'}`}
                                            ></i>
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className="fw-semi-bold text-800 fs--1 mb-1">
                                            {movimiento.descripcion}
                                        </div>
                                        <div className="fs--2 mt-1 d-flex align-items-center">
                                            <Badge bg="soft-primary" text="primary" className="me-2 d-flex align-items-center gap-1 border border-primary-subtle py-1 px-2">
                                                <i className="far fa-calendar"></i>
                                                {formatearFecha(movimiento.fecha)}
                                            </Badge>
                                            <span className="text-600">
                                                <i className="fas fa-hashtag me-1"></i>
                                                {movimiento.referencia}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col xs={3} className="text-end">
                                        <div
                                            className={`fw-bold fs-0 ${movimiento.tipo === 'I' ? 'text-success' : 'text-danger'}`}
                                        >
                                            {movimiento.tipo === 'I' ? '+' : '-'}

                                            ${(esConciliadosTab ? movimiento.montoConciliado : movimiento.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                        </div>
                                        {!esConciliadosTab && movimiento.montoConciliado > 0 && (
                                            <div className="fs--2 text-warning mt-1 fw-semi-bold text-end">
                                                <i className="fas fa-exclamation-triangle me-1"></i>
                                                Saldo restante
                                                <div className="text-muted fw-normal mt-1">
                                                    Original: ${(movimiento.montoOriginal || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </ListGroup.Item>
                        ))}
                    </>
                ) : (
                    <ListGroup.Item className="text-center text-600 py-4">
                        <i className="fas fa-info-circle me-2"></i>
                        No hay movimientos para el período seleccionado
                    </ListGroup.Item>
                )}
            </ListGroup>
        </div>
    );
};



EstadoCuentaLista.propTypes = {
    rfcSeleccionado: PropTypes.string,
    movimientosFiltrados: PropTypes.array
};

export default EstadoCuentaLista;
